<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-user-dropdown
      name="privateUsers"
      formControlName="privateUsers"></app-user-dropdown>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      *ngIf="
        !itemToEdit ||
        (itemToEdit &&
          this.activeUserStore.user() &&
          itemToEdit.user === this.activeUserStore.user()?._id)
      "
      [colSize]="4"
      [label]="'Privat'"
      [name]="'private'"
      [floatingLabel]="true">
      <p-inputSwitch id="private" formControlName="private"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider />
  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="bookmarkCategory"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>
  <p-divider />
  <app-form-footer
    [cancelLevel]="cancelLevel"
    (cancel)="cancel.emit()"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!itemToEdit &&
      permissionService.checkBookmarkRights(itemToEdit._id, 'remove')
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
